function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#CCC",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M5.37 15.012c.845 0 1.562-.269 2.148-.806.586-.537.878-1.213.878-2.026 0-.423-.089-.814-.268-1.172-.18-.358-.407-.668-.684-.928-.276-.26-.594-.448-.952-.561-.358-.114-.732-.123-1.123-.025l-.586.195c-.195.066-.366.066-.512 0-.147-.065-.22-.276-.22-.634 0-1.075.309-2.051.928-2.93.618-.879 1.562-1.611 2.832-2.197L7.127 3c-1.758.651-3.052 1.636-3.882 2.954C2.415 7.272 2 8.811 2 10.568c0 1.302.277 2.369.83 3.199.553.83 1.4 1.245 2.54 1.245zm7.812 0c.846 0 1.554-.269 2.124-.806.57-.537.854-1.213.854-2.026 0-.847-.31-1.547-.928-2.1-.618-.553-1.302-.749-2.05-.586l-.586.195c-.228.066-.415.066-.562 0-.146-.065-.22-.276-.22-.634 0-1.075.318-2.051.953-2.93.634-.879 1.587-1.611 2.856-2.197L14.939 3c-1.757.651-3.06 1.636-3.906 2.954-.846 1.318-1.27 2.857-1.27 4.614 0 1.302.286 2.369.855 3.199.57.83 1.424 1.245 2.564 1.245z",
  transform: "translate(-170 -231) translate(20 231) translate(151)"
})))));

function SvgQuotesStartGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotesStartGray);
export default __webpack_public_path__ + "static/media/quotes-start-gray.93ab2428.svg";
export { ForwardRef as ReactComponent };